export default {"src":"/_next/static/media/countries.7a2ec41e.svg","height":159,"width":306,"blurWidth":0,"blurHeight":0};